import { usePermission } from "@/permissions";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const RedirectToLandingPage = () => {
  const { hasPermission } = usePermission();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      hasPermission([
        "corporate_coordinator",
        "site_coordinator",
        "super_admin",
        "data_provider",
        "reviewer",
        "verifier",
      ])
    ) {
      navigate("/assessments");
    } else if (hasPermission("sme_user")) {
      navigate("/protocol_sets");
    } else if (hasPermission("organisation_admin")) {
      navigate("/users");
    }
  }, []);

  return null;
};
